'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createIntlSelector = createIntlSelector;

var _messageformat = require('messageformat');

var _messageformat2 = _interopRequireDefault(_messageformat);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIntlValid = function isIntlValid(intl) {
  return !(0, _isEmpty2.default)(intl) && intl.locale;
};

var isCacheHit = function isCacheHit(intl, cache) {
  return cache.locale === intl.locale && !intl.cacheDisable;
};

var compileMessages = function compileMessages(intl) {
  return new _messageformat2.default(intl.locale).setIntlSupport(intl.ecmaSupport).compile(intl.messages);
};

function createIntlSelector() {
  var cache = {};

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var intl = state.intl;


    if (!isIntlValid(intl)) {
      cache = {};
      return cache;
    }

    if (isCacheHit(intl, cache)) {
      return cache;
    }

    cache = _extends({}, intl, {
      messages: compileMessages(intl)
    });

    return cache;
  };
}

exports.default = createIntlSelector();


//////////////////
// WEBPACK FOOTER
// ./~/redux-intl-connect/lib/intlSelector.js
// module id = 328
// module chunks = 0